<template>
  <div class="featured">
    <h1 class="fz-24">{{ themeName }}</h1>
    <div class="featured-wrap">
      <swiper :slides-per-view="'auto'" :key="Math.random()">
        <swiper-slide v-for="data in featuredSliderData" :key="data.id">
          <FeaturedPodcast
            :featured-podcast="data"
            :display-info="displayInfo"
            @click="openCourse(data)"
          />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { TRACKING_FEATURED_COURSE_VIEW } from '@/config/constants';

import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

import useTracking from '@/composables/useTracking';
import FeaturedPodcast from '@/components/common/FeaturedPodcast.vue';

defineOptions({
  name: 'FeaturedSlider',
});

const props = defineProps({
  featuredSliderData: {
    type: Array,
    required: true,
  },
  themeName: {
    type: String,
    required: true,
  },
});

const displayInfo = props.themeName !== 'Geaccrediteerde podcasts';

const router = useRouter();
const store = useStore();
const { trackThis } = useTracking();

async function openCourse(featuredData) {
  const { id, course_id, entity_type } = featuredData;

  trackThis(TRACKING_FEATURED_COURSE_VIEW, {}, id);
  store.commit('course/setCourseTrackingState', false);

  if (['series', 'season'].includes(entity_type)) {
    router.push(`/course/${course_id}`);
  } else if (entity_type === 'episode') {
    const course = await store.dispatch('course/setCourseData', course_id);

    if (!course.streams.length) {
      router.push(`/course/${course_id}`);
      return;
    }

    store.dispatch('player/openPlayer', {
      course,
      company: course.company,
      playlist: course.streams,
      startAt: 0,
    });
  }
}
</script>

<style scoped lang="scss">
.featured-wrap {
  .swiper {
    width: 100%;
  }

  .swiper-slide {
    width: auto;
    text-align: left;
  }
}
</style>
